import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse, PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import { TemplatesServiceCapabilities } from './templates.types'
import {
  CreateSurveyTemplatePayload,
  GetSurveyTemplatesListProps,
  SurveyTemplate,
  SurveyTemplateDetail,
  UpdateSurveyTemplatePayload
} from './surveyTemplateService.types'

export const surveyTemplateService = ({ percentClient }: TemplatesServiceCapabilities) => ({
  getSurveyTemplatesList: (params: GetSurveyTemplatesListProps) => {
    const { query, status, surveyType, direction, sort, ...otherParams } = params

    return percentClient.get<PBPListResponse<SurveyTemplate>>(`${baseUrl}volunteering/survey-templates`, {
      params: {
        ...otherParams,
        ...(query && { query }),
        ...(status?.length && { status }),
        ...(surveyType && { surveyType }),
        ...(sort && { sort }),
        ...(direction && { direction })
      }
    })
  },
  getSurveyTemplate: (templateId: string) => {
    return percentClient.get<PBPResponse<SurveyTemplateDetail>>(`${baseUrl}volunteering/survey-templates/${templateId}`)
  },
  createSurveyTemplate: (payload: CreateSurveyTemplatePayload) => {
    return percentClient.post<PBPResponse<SurveyTemplateDetail>>(`${baseUrl}volunteering/survey-templates`, payload)
  },
  updateSurveyTemplate: ({ templateId, ...payload }: UpdateSurveyTemplatePayload) => {
    return percentClient.patch<PBPResponse<SurveyTemplateDetail>>(
      `${baseUrl}volunteering/survey-templates/${templateId}`,
      payload
    )
  },
  archiveSurveyTemplate: (templateId: string) => {
    return percentClient.delete(`${baseUrl}volunteering/survey-templates/${templateId}`)
  },
  setDefaultSurveyTemplate: (templateId: string) => {
    return percentClient.post(`${baseUrl}volunteering/survey-templates/${templateId}/default`)
  },
  removeDefaultSurveyTemplate: (templateId: string) => {
    return percentClient.delete(`${baseUrl}volunteering/survey-templates/${templateId}/default`)
  }
})
